import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

function NavSectionComponent(
  { children, ...props }: HTMLProps<HTMLUListElement>,
  ref: LegacyRef<HTMLUListElement>
) {
  return (
    <ul ref={ref} {...props} className={`nav-section ${props.className || ''}`}>
      {children}
    </ul>
  );
}

export default forwardRef(NavSectionComponent);
